<template>
  <section class="businesses">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <div
        v-if="loading"
        class="d-flex p-2 spinner-border loading-spinner mx-auto"
        role="status"
      >
        <span class="sr-only">{{ $t("lang.search.loading") }}...</span>
      </div>
      <div v-if="!loading">
        <!-- <Promotion
          v-if="
            user.plan_id == 3 &&
              user.is_agency == 1 &&
              user.order_created == 1 &&
              totalContacts == 0 &&
              !cancelPromotion &&
              user.role_id != 3
          "
          @cancel="cancel($emit)"
        />
        <div> -->
          <PreparingApp
            :user="user"
            v-if="user.order_created == 1 || user.role_id == 3"
          />

          <div class="ml-2 mr-2" v-else>
            <div class="row mt-5 justify-content-center">
              <div class="col-2 d-flex justify-content-center">
                <RoundedBox v-if="onBoarding.substep > 0"
                  :step="onBoarding.step"/>
              </div>
              <div class="col-8 d-flex justify-content-center">
                <Stepper
                  v-if="onBoarding.substep > 0"
                  :step="onBoarding.step"
                />
              </div>
              <div class="col-2"></div>
              <div class="col-md-11">
                <MultiStep
                  v-if="!loading"
                  :targetId="targetId"
                  :typeForm="'onboarding'"
                />
              </div>
              <div class="col-md-2" v-if="onBoarding.step == 1"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import MultiStep from "@/components/Onboarding/MultiStep.vue";
import Summary from "@/components/Onboarding/Summary.vue";
import Stepper from "@/components/Onboarding/Stepper.vue";
import { mapState, mapActions } from "vuex";
import {
  targetsService,
  usersService,
  businessContactsService
} from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import PreparingApp from "@/components/PreparingApp.vue";
import Promotion from "@/views/Promotion.vue";
import RoundedBox from "../components/Onboarding/RoundedBox.vue";
import Header from "@/components/Header.vue";


export default {
  data() {
    return {
      conditionPayment: 'ok',
      totalContacts: 0,
      cancelPromotion: false,
      targetId: false,
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" }
      ],
      size: [],
      model: {
        currentPage: 1,
        status: { buy: true }
      }
    };
  },
  mounted() {
    this.udpdateHeader('onboarding_route');

  },
  created() {
    this.setLoading(true);
    this.$store.dispatch("authentication/refreshToken");
    businessContactsService.total(this.model).then(response => {
      if (response !== undefined) {
        this.totalContacts = parseInt(response.total);
      }
    });

    this.targetId = false;
    if (
      this.user.plan_id == 3 &&
      this.user.is_agency == 1 &&
      this.user.order_created == 1
    ) {
      this.setLoading(false);
    } else {
      if (this.user.order_created == 0) {
        targetsService.getAll().then(response => {
          if (response.length > 0) {
            this.goToStep(1);
            this.goToSubStep(1);
            this.targetId = response[response.length - 1].id;
          }
          if (this.targetId) {
            this.loadTarget(this.targetId);
          } else {
            this.$forceUpdate();
            this.clean();
            this.goToStep(1);
            this.goToSubStep(0);
            +this.setLoading(false);
          }

          if (this.targetId) {
            this.conditionPayment = this.$route.query.conditionPayment;
            if(this.conditionPayment == 'error'){
              this.loadTarget(this.targetId);
              this.goToStep(3);
              this.goToSubStep(1);
              this.updateConditionPayment('error')
            } else {
              this.goToStep(1);
              this.goToSubStep(1);
            }
            // if (this.$route.params.step == undefined) {
            //   this.goToStep(3);
            //   this.goToSubStep(1);
            // } else {
            //   this.goTo(this.$route.params);
            // }
          }
        });
      } else {
        if (this.user.payment_method_confirmed == 1) {
          targetsService.getAll().then(res => {
            if (res.length > 0) {
              this.targetId = res[res.length - 1].id;
            }
            if (this.targetId) {
              this.setOrderId(this.targetId);
              this.conditionPayment = this.$route.query.conditionPayment;

              //Si viene luego de haber cargado exitosamente su tarjeta de credito.
              if(this.conditionPayment == 'ok') {
                //Actualizo esta propiedad para que en onbording cuando ejecute el motodo loadTarget
                // guarde en la bd esta order con status active.
                this.updateStatusToPreapring(true);
              }
              this.loadTarget(this.targetId);
              this.goToStep(3);
              this.goToSubStep(1);
              this.updateConditionPayment('ok')
            }
          })
          // this.goToStep(3);
          // this.goToSubStep(1);
          // this.setLoading(false)
        } else {
          this.$router.push("/onboarding");
          this.setLoading(false);
        }
      }
    }
  },
  components: {
    MultiStep,
    Summary,
    LoadingSpinner,
    PreparingApp,
    Promotion,
    Stepper,
    RoundedBox,
    Header

},
  computed: {
    ...mapState({
      onBoarding: state => state.onboarding,
      loading: state => state.onboarding.loading,
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      user: state => state.authentication.user,
      headerTab: state => state.header.tab

    })
  },
  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    ...mapActions("onboarding", {
      goToStep: "goToStep",
      updateConditionPayment: "updateConditionPayment",
      goTo: "goTo",
      goToSubStep: "goToSubStep",
      loadTarget: "loadTarget",
      clean: "clean",
      setLoading: "setLoading",
      setOrderData: "setOrderData",
      setOrderId: "setOrderId",
      updateStatusToPreapring: "updateStatusToPreapring",
    }),

    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },

    sendToStep(step, substep) {
      this.goToStep(step);
      this.goToSubStep(substep);
    },
    cancel($emit) {
      this.cancelPromotion = $emit;
    }
  }
};
</script>

